
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.464 24.12H7.8a5.519 5.519 0 01-.6-.028 6.767 6.767 0 01-1.964-13.02 8.581 8.581 0 013.04-4.351 8.559 8.559 0 0112.585 2.6 5.965 5.965 0 015.016 4.32 5.509 5.509 0 01-2.24 10.472c-.057.007-.108.007-.173.007zm-10.04-16.2A5.606 5.606 0 007.8 13.492a3.853 3.853 0 00-.309 7.695 2.141 2.141 0 00.309.013h15.728a2.6 2.6 0 00-.064-5.2 2.652 2.652 0 00-.4.028 3.013 3.013 0 00.112-.8 3.055 3.055 0 00-3.064-3.04 3 3 0 00-1.176.232 5.608 5.608 0 00-5.512-4.504z","fill":"#222"}})])
          )
        }
      }
    